<template>
  <div class="collapsed-footered">
    <div class="collapsed-footer__head" @click="toggleCollapse">
      <div class="collapsed-footer__head-title">
        <slot name="head" />
      </div>
      <div :class="{open: !isCollapsed, collapsed: isCollapsed}" class="collapsed-footer__head-ico">
        <svg enable-background="new 0 0 14 9" viewBox="0 0 14 9" xmlns="http://www.w3.org/2000/svg">
          <path
            clip-rule="evenodd"
            d="m.3 1.4 1.4-1.4 5.3 5.3 5.3-5.3 1.4 1.4-6.7 6.7z"
            fill="currentColor"
            fill-rule="evenodd"
          />
        </svg>
      </div>
    </div>
    <div ref="collapse" :class="{open: !isCollapsed, collapsed: isCollapsed}" class="collapsed-footer__content">
      <slot name="content" />
    </div>
    <div class="collapsed-footer__footer">
      <slot name="footer" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'CollapseFootered',
  props: {
    isOpen: {
      type: Boolean,
    },
  },
  data() {
    return {
      isCollapsed: false,
    };
  },
  watch: {
    isOpen(val) {
      this.isCollapsed = !val;
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const collapse = this.$refs.collapse;
        const contentHeight = collapse.scrollHeight;
        collapse.style.setProperty('--fullHeight', `${contentHeight}px`);
      }, 400);
    });
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>
<style scoped>
.collapsed-footered {
  --collapsedHeight: 0px;
  --fullHeight: 0px;
  border: 1px solid var(--grey);
  border-radius: 8px;
}
.collapsed-footer__head {
  display: grid;
  grid-template-columns: 1fr 10px;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.collapsed-footer__head-title {
  padding: 10px;
}
.collapsed-footer__footer {
  border-top: solid 1px var(--light-grey);
  margin: 0 13px 0 13px;
  padding: 15px 0;
}
.collapsed-footer__head-ico {
  position: absolute;
  right: 10px;
  top: 14px;
  width: 14px;
  height: 9px;
  color: var(--grey);
}
.collapsed-footer__head-ico.open {
  transform: rotate(180deg);
}
.collapsed-footer__head-ico svg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.collapsed-footer__content {
  height: var(--collapsedHeight);
  overflow: hidden;
  transition: all 0.3s ease-out;
}
.collapsed-footer__content.collapsed {
  height: var(--collapsedHeight);
}
.collapsed-footer__content.open {
  height: var(--fullHeight);
}
@keyframes collapse {
  from {
    height: var(--fullHeight);
  }
  to {
    height: var(--collapsedHeight);
  }
}
@keyframes open {
  from {
    height: var(--collapsedHeight);
  }
  to {
    height: var(--fullHeight);
  }
}
</style>
